<template>
    <video autoplay="" muted="" loop="" id="background-video" style="opacity: 1;">
        <source src="/site_assets/backgrounds/background_video.mp4" type="video/mp4">
    </video>
    <div class="contact">
      <section class="partie">
        <a href="https://www.instagram.com/emilyrosest/" target="_blank"><h2>instagram</h2></a>
        <a href="https://www.linkedin.com/in/emily-rose-strich/" target="_blank"><h2>linkedin</h2></a>
        <a href="mailto:er.strich@hotmail.fr"><h2>er.strich@hotmail.fr</h2></a>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ContactPage'
  };
  </script>
  
  <style scoped>
    video {
    object-fit: contain;
    overflow-clip-margin: content-box;
    overflow: clip;
  }
  #background-video {
    position: fixed;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;
    z-index: -10;
  }
  .contact {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 40px;
  }
  .partie {
    margin-top: 60px;
    padding: 20px;
    min-width: 20%;
    max-width: 50%;
    background-image: url(../../public/site_assets/papers/paper.jpg);
    background-position-x: center;
    background-position-y: center;
  }

  a {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 20px;
    }

    .partie {
      max-width: 80%;
    }

    h2 {
      padding: 10px 0;
    }
  }

</style>